import React from 'react';

type Component = React.ComponentClass<any, any> | React.FC<any>;

export const getDisplayName = (
  Component: Component | string,
): string | undefined => {
  if (typeof Component === 'string') {
    return Component;
  }
  if (!Component) {
    return undefined;
  }
  return Component.displayName || Component.name || 'Component';
};
